import Joi from 'joi';

export const AppointmentRegionSchema = Joi.object({
  appointmentId: Joi.number().required(),
  regionId: Joi.number().required(),
  provinces: Joi.array().items(Joi.string()).min(1).required()
});
